// extracted by mini-css-extract-plugin
export default {"container":"sectionHeader_container__-0Anu","line":"sectionHeader_line__QRl8o","title":"sectionHeader_title__K+g1W"};